import { Vector3 } from "three";
import { HotspotControllerState } from "../components/HotspotController";

const mod = () => {
  // object containing map of hotspotKey => {point3D, point2D}
  const hotspots = {};

  return {
    addHotspot: (modelId, point3D) => {
      console.log("adding hotspot for ", modelId, point3D);
      hotspots[modelId] = {
        point3D,
        point3dCurrent: new Vector3(0, 0, 0),
        divRef: null,
      };
      HotspotControllerState().addHotspot(modelId);
    },
    updateHotspots: (camera) => {
      const { innerHeight, innerWidth } = window;
      if (Object.keys(hotspots).length > 0) {
        // console.log("updating hotspots", hotspots);
        Object.keys(hotspots).forEach((hotspotId) => {
          // console.log(
          //   "hotspot ref",
          //   HotspotControllerState().hotspotRefs[hotspotId]
          // );
          if (hotspots[hotspotId].divRef == null) {
            if (HotspotControllerState().hotspotRefs[hotspotId] == null) return;
            hotspots[hotspotId].divRef =
              HotspotControllerState().hotspotRefs[hotspotId];
          }
          hotspots[hotspotId].point3dCurrent.x = hotspots[hotspotId].point3D.x;
          hotspots[hotspotId].point3dCurrent.y = hotspots[hotspotId].point3D.y;
          hotspots[hotspotId].point3dCurrent.z = hotspots[hotspotId].point3D.z;
          hotspots[hotspotId].point3dCurrent.project(camera);
          const x =
            (hotspots[hotspotId].point3dCurrent.x * 0.5 + 0.5) * innerWidth;
          const y =
            (hotspots[hotspotId].point3dCurrent.y * 0.5 + 0.5) * innerHeight;

          hotspots[hotspotId].divRef.style.bottom = `${y}px`;
          hotspots[hotspotId].divRef.style.left = `${x}px`;
        });
      }
    },
  };
};

const HotspotHelper = mod();
export default HotspotHelper;
